<template>
  <div>
  <div class="c-app flex-row align-items-center d-sm-down-none">
    <CRow class="p-0">
  <CCol sm="3" class="p-0">
 <TheSidebar></TheSidebar></CCol>
  <CCol sm="6" class="p-0">
    <div class="header-top">
      <CRow>
          <span class="custom-header-profile">
          <img
            v-if="studentProfileAuthorize == ''"
            width="50px"
            height="50px"
            src="../../assets/img/icon/icondefault.svg"
          />
          <img
            v-else
            width="50px"
            height="50px"
            :src="photoURL"
            style="border-radius: 50%; border: 5px solid #fff"
          />
        </span>
        <div>
          <span>
            <span class="custom-user-title text-white"
              >Hello {{ user.name }} !</span
            >
            <label class="label-greeting text-white"
              >Teacher <br /><br />
              <CProgress
                :value="value"
                :max="max2"
                class="mb-3"
                color="white"
                style="min-width: 200px; display: inline-grid"
              />
              <img src="../../assets/img/icon/point.svg" class="ml-2" />
              <br />
              <div style="min-width: 200px">
                <span class="float-left">
                  <span class="custom-credit">Redeem</span>
                </span>
              </div>
              <span class="float-right">1950/2000 pts</span>
            </label>
            <br /><br />
          </span>
          <span>
            <img
              style="position: absolute; top: 0; right: 30px"
              src="../../assets/img/icon/setting.svg" @click="GoToSetting()"
            />
          </span>

          <div style="clear: both"></div>
        </div>
      </CRow>
    </div>
    <CContainer style="justify-content: center;margin-top:0px" class="p-0 mt-5">
      <br /><br /> <br />
      <div class="container-box-new center">
        <div class="text-left">
          <div class="card-custom-web-new">
            <br />

            <CCard class="ml-3 mr-3">
              <CCardBody>
                <div class="float-left">                  
                  <label class="custom-label-muted">Available Credits</label>
                  <h4><strong>
                    {{ wallet.currentAmount }} Credits
                  </strong></h4>
                  <label class="custom-text-history" @click="GoToHistory()">View history</label>
                </div>
                <div class="float-right">
                  <span class="custom-topup" @click="GoToTopup()">
                    + <label class="ml-3 mr-2">Topup</label></span
                  >
                </div>
              </CCardBody>
            </CCard>

            <CCard class="ml-3 mr-3">
              <CCardBody>
                <div class="float-left">                  
                  <label class="custom-label-muted">Bill Due</label>
                  <h4><strong>
                    {{ user.currencyCode }} {{ payment.totalUnpaid }}
                  </strong></h4>
                  <!-- <label class="custom-text-history" @click="GoToHistory()">View history</label> -->
                </div>
                <div class="float-right">
                  <span class="custom-topup" @click="GoToBill()">
                    <label class="ml-3 mr-2">View Bill</label>
                  </span>
                </div>
              </CCardBody>
            </CCard>

            <div class="float-left ml-3">
              <strong class="custom-text-hotpick ml-1">My Workspace</strong>
            </div>
            <br /> <br />
            <div style="clear: both"></div>

            <CRow class="justify-content-center mb-2">
              <CCol
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <CCol sm="12" lg="12">
                  <CCol
                    sm="12"
                    lg="12"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      left: 0;
                      right: 0;
                      bottom: 0px;
                    "
                  >
                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" @click="GoToTutorSchedule()">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/calendar.svg" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Schedule</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" @click="GoToTutorJob()">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/job.svg" />
                          <br />
                          <label class="text-icon custom-font-cards"> Job</label>
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/quiz.svg" style="filter: grayscale(1);"/>
                          <br />
                          <label class="text-icon custom-font-cards">
                            Quiz</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" @click="GoToStudent()">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/students.svg" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Students</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>
                  </CCol>
                </CCol>
              </CCol>
            </CRow>

            <CRow class="justify-content-center mb-2">
              <CCol
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <CCol sm="12" lg="12">
                  <CCol
                    sm="12"
                    lg="12"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      left: 0;
                      right: 0;
                      bottom: 0px;
                    "
                  >
                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/exam.svg" style="filter: grayscale(1);" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Exam</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" @click="GotoSalaryTutor()" >
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/salary.svg" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Salary</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none;"  class="text-center p-1" @click="GoToAttendance()">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/attendance.svg" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Attendance</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/chat.svg" style="filter: grayscale(1);" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Chat</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>
                  </CCol>
                </CCol>
              </CCol>
            </CRow>

            <div class="float-left ml-3 mt-3">
              <strong class="custom-text-hotpick ml-1"> Myself / My Child </strong>
            </div>
            <div class="float-right mr-3 mt-3">
              <strong class="custom-text-viewall mr-1" @click="GoToManageStudent">Manage</strong>
            </div>
            <br /> <br />
            <div style="clear: both"></div>

         

            <div class="ml-3 mr-3 mb-3">
              <hooper
                settings="hooperSettings"
                ref="hooper"
                :itemsToShow="2"
                pagination="yes"
                class="d-sm-down-none"
              >
                <slide
                  v-for="(slide,index) in childs.Students"
                  :key="slide.Id"
                  :index="slide.Id"
                >
                  <CCard
                    style="border-radius: 10px; height: 150px"
                    class="mr-3"
                  >
                    <CCardBody>
                      <CRow>
                        <span style="width:30%" class="float-left">
                        <span class="custom-header-profile">
                          <img
                            v-if="slide.profileImagePath == null"
                            style="
                              width: 50px;
                              height: 50px;
                              object-fit: cover;
                            "
                            src="../../assets/img/icon/icondefault.svg"
                          />

                          <img
                            v-else
                            style="
                              background: #fff;
                              width: 50px;
                              height: 50px;
                              border-radius:50%
                            "
                            :src="getPicChild(index)"
                          />
                          </span>
                        </span>
                        <span style="width:70%" class="float-right">
                          <span>
                            <span class="custom-user-title">{{
                              slide.studentName
                            }}</span>
                            <label class="custom-label-muted">{{
                              slide.grade
                            }}</label>
                            <br />
                            <span v-for="item in slide.focusSubjectJsons" v-bind:key="item.Id">
                            <span class="custom-badge-subject mr-2">{{ item.subjectName }}</span>
                            </span>
                          </span>
                           <span>
                        <span class="custom-type-exam">
                          <label class="ml-2">{{ slide.examShortName }}</label>
                        </span>
                      </span>
                          <div style="clear: both"></div>
                          </span>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
                <hooper-pagination slot="hooper-addons"></hooper-pagination>
              </hooper>
            </div>

            <div class="ml-3 mr-3 mb-3">
              <hooper
                settings="hooperSettings"
                ref="hooper"
                :itemsToShow="1"
                pagination="yes"
                class="d-sm-flex d-md-none"
              >
                 <slide
                  v-for="(slide,index) in childs.Students"
                  :key="slide.Id"
                  :index="slide.Id"
                >
                  <CCard
                    style="border-radius: 10px; height: 150px"
                    class="mr-3"
                  >
                    <CCardBody>
                      <CRow>
                        <span style="width:30%" class="float-left">
                        <span class="custom-header-profile">
                          <img
                            v-if="slide.profileImagePath == null"
                            style="
                              width: 50px;
                              height: 50px;
                              object-fit: cover;
                            "
                            src="../../assets/img/icon/icondefault.svg"
                          />

                          <img
                            v-else
                            style="
                              background: #fff;
                              width: 50px;
                              height: 50px;
                              border-radius:50%
                            "
                            :src="getPicChild(index)"
                          />
                          </span>
                        </span>
                        <span style="width:70%" class="float-right">
                          <span>
                            <span class="custom-user-title">{{
                              slide.studentName
                            }}</span>
                            <label class="custom-label-muted">{{
                              slide.grade
                            }}</label>
                            <br />
                            <span v-for="item in slide.focusSubjectJsons" v-bind:key="item.Id">
                            <span class="custom-badge-subject mr-2">{{ item.subjectName }}</span>
                            </span>
                          </span>
                           <span>
                        <span class="custom-type-exam">
                          <label class="ml-2">{{ slide.examShortName }}</label>
                        </span>
                      </span>
                          <div style="clear: both"></div>
                          </span>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </slide>


                <hooper-navigation slot="hooper-addons"></hooper-navigation>
                <hooper-pagination slot="hooper-addons"></hooper-pagination>
              </hooper>
            </div>

            <CCard class="custom-reward mb-5 ml-3 mr-3">
              <CRow>
                <div style="width: 70%" class="float-left">
                  <h3
                    style="text-align: left"
                    class="sub-title-header ml-4 mt-4 mb-4"
                  >
                    Redeem Rewards <br />
                    <label class="sub-title-card">
                      Claim Reward Points <br />
                      and enjoy more discount <br />
                      with Pickiddo</label
                    >
                    <CButton color="info" class="custom-header-btn mt-3">
                      Redeem Now</CButton
                    >
                  </h3>
                </div>
                <div style="width: 30%" class="float-right">
                  <img
                    style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                    src="../../assets/img/icon/reward.svg"
                  />
                </div>
              </CRow>
            </CCard>
            <br /><br />

            <MainlayoutBottom class="d-md-none d-lg-none"></MainlayoutBottom>
            <div style="clear: both"></div>
          </div>
        </div>
      </div>
    </CContainer>
   
    </CCol>
    <CCol sm="3" class="p-0">
      <TheSidebarRight class="mt-3"></TheSidebarRight></CCol>
    </CRow>
    </div>

    <div class="c-app-new flex-row align-items-center d-md-none d-lg-none">
      <CRow class="p-0">
        <CContainer style="display: flex; justify-content: center" class="p-0 mt-4">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <CCard class="ml-3 mr-3">
              <CCardBody>
                <div class="float-left">                  
                  <label class="custom-label-muted">Available Credits</label>
                  <h4><strong>
                    {{ wallet.currentAmount }} Credits
                  </strong></h4>
                  <label class="custom-text-history" @click="GoToHistory()">View history</label>
                </div>
                <div class="float-right">
                  <span class="custom-topup" @click="GoToTopup()">
                    + <label class="ml-3 mr-2">Topup</label></span
                  >
                </div>
              </CCardBody>
            </CCard>

            <CCard class="ml-3 mr-3">
              <CCardBody>
                <div class="float-left">                  
                  <label class="custom-label-muted">Bill Due</label>
                  <h4><strong>
                    {{ user.currencyCode }} {{ payment.totalUnpaid }}
                  </strong></h4>
                  <!-- <label class="custom-text-history" @click="GoToHistory()">View history</label> -->
                </div>
                <div class="float-right">
                  <span class="custom-topup" @click="GoToBill()">
                    <label class="ml-3 mr-2">View Bill</label>
                  </span>
                </div>
              </CCardBody>
            </CCard>

            <div class="float-left ml-3">
              <strong class="custom-text-hotpick ml-1">My Workspace</strong>
            </div>
            <br /> <br />
            <div style="clear: both"></div>

            <CRow class="justify-content-center mb-2">
              <CCol
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <CCol sm="12" lg="12">
                  <CCol
                    sm="12"
                    lg="12"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      left: 0;
                      right: 0;
                      bottom: 0px;
                    "
                  >
                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" @click="GoToTutorSchedule()">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/calendar.svg" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Schedule</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" @click="GoToTutorJob()">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/job.svg" />
                          <br />
                          <label class="text-icon custom-font-cards"> Job</label>
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/quiz.svg" style="filter: grayscale(1);"/>
                          <br />
                          <label class="text-icon custom-font-cards">
                            Quiz</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" @click="GoToStudent()">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/students.svg" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Students</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>
                  </CCol>
                </CCol>
              </CCol>
            </CRow>

            <CRow class="justify-content-center mb-2">
              <CCol
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <CCol sm="12" lg="12">
                  <CCol
                    sm="12"
                    lg="12"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      left: 0;
                      right: 0;
                      bottom: 0px;
                    "
                  >
                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/exam.svg" style="filter: grayscale(1);" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Exam</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" @click="GotoSalaryTutor()" >
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/salary.svg" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Salary</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none;"  class="text-center p-1" @click="GoToAttendance()">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/attendance.svg" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Attendance</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/chat.svg" style="filter: grayscale(1);" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Chat</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>
                  </CCol>
                </CCol>
              </CCol>
            </CRow>

            <div class="float-left ml-3 mt-3">
              <strong class="custom-text-hotpick ml-1"> Myself / My Child </strong>
            </div>
            <div class="float-right mr-3 mt-3">
              <strong class="custom-text-viewall mr-1" @click="GoToManageStudent">Manage</strong>
            </div>
            <br /> <br />
            <div style="clear: both"></div>

         

            <div class="ml-3 mr-3 mb-3">
              <hooper
                settings="hooperSettings"
                ref="hooper"
                :itemsToShow="2"
                pagination="yes"
                class="d-sm-down-none"
              >
                <slide
                  v-for="(slide,index) in childs.Students"
                  :key="slide.Id"
                  :index="slide.Id"
                >
                  <CCard
                    style="border-radius: 10px; height: 150px"
                    class="mr-3"
                  >
                    <CCardBody>
                      <CRow>
                        <span style="width:30%" class="float-left">
                        <span class="custom-header-profile">
                          <img
                            v-if="slide.profileImagePath == null"
                            style="
                              width: 50px;
                              height: 50px;
                              object-fit: cover;
                            "
                            src="../../assets/img/icon/icondefault.svg"
                          />

                          <img
                            v-else
                            style="
                              background: #fff;
                              width: 50px;
                              height: 50px;
                              border-radius:50%
                            "
                            :src="getPicChild(index)"
                          />
                          </span>
                        </span>
                        <span style="width:70%" class="float-right">
                          <span>
                            <span class="custom-user-title">{{
                              slide.studentName
                            }}</span>
                            <label class="custom-label-muted">{{
                              slide.grade
                            }}</label>
                            <br />
                            <span v-for="item in slide.focusSubjectJsons" v-bind:key="item.Id">
                            <span class="custom-badge-subject mr-2">{{ item.subjectName }}</span>
                            </span>
                          </span>
                           <span>
                        <span class="custom-type-exam">
                          <label class="ml-2">{{ slide.examShortName }}</label>
                        </span>
                      </span>
                          <div style="clear: both"></div>
                          </span>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
                <hooper-pagination slot="hooper-addons"></hooper-pagination>
              </hooper>
            </div>

            <div class="ml-3 mr-3 mb-3">
              <hooper
                settings="hooperSettings"
                ref="hooper"
                :itemsToShow="1"
                pagination="yes"
                class="d-sm-flex d-md-none"
              >
                 <slide
                  v-for="(slide,index) in childs.Students"
                  :key="slide.Id"
                  :index="slide.Id"
                >
                  <CCard
                    style="border-radius: 10px; height: 150px"
                    class="mr-3"
                  >
                    <CCardBody>
                      <CRow>
                        <span style="width:30%" class="float-left">
                        <span class="custom-header-profile">
                          <img
                            v-if="slide.profileImagePath == null"
                            style="
                              width: 50px;
                              height: 50px;
                              object-fit: cover;
                            "
                            src="../../assets/img/icon/icondefault.svg"
                          />

                          <img
                            v-else
                            style="
                              background: #fff;
                              width: 50px;
                              height: 50px;
                              border-radius:50%
                            "
                            :src="getPicChild(index)"
                          />
                          </span>
                        </span>
                        <span style="width:70%" class="float-right">
                          <span>
                            <span class="custom-user-title">{{
                              slide.studentName
                            }}</span>
                            <label class="custom-label-muted">{{
                              slide.grade
                            }}</label>
                            <br />
                            <span v-for="item in slide.focusSubjectJsons" v-bind:key="item.Id">
                            <span class="custom-badge-subject mr-2">{{ item.subjectName }}</span>
                            </span>
                          </span>
                           <span>
                        <span class="custom-type-exam">
                          <label class="ml-2">{{ slide.examShortName }}</label>
                        </span>
                      </span>
                          <div style="clear: both"></div>
                          </span>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </slide>


                <hooper-navigation slot="hooper-addons"></hooper-navigation>
                <hooper-pagination slot="hooper-addons"></hooper-pagination>
              </hooper>
            </div>

            <CCard class="custom-reward mb-5 ml-3 mr-3">
              <CRow>
                <div style="width: 70%" class="float-left">
                  <h3
                    style="text-align: left"
                    class="sub-title-header ml-4 mt-4 mb-4"
                  >
                    Redeem Rewards <br />
                    <label class="sub-title-card">
                      Claim Reward Points <br />
                      and enjoy more discount <br />
                      with Pickiddo</label
                    >
                    <CButton color="info" class="custom-header-btn mt-3">
                      Redeem Now</CButton
                    >
                  </h3>
                </div>
                <div style="width: 30%" class="float-right">
                  <img
                    style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                    src="../../assets/img/icon/reward.svg"
                  />
                </div>
              </CRow>
            </CCard>
            <br /><br />

            <MainlayoutBottom></MainlayoutBottom>
            <div style="clear: both"></div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="header-top">
      <CRow>
          <span class="custom-header-profile">
          <img
            v-if="studentProfileAuthorize == ''"
            width="50px"
            height="50px"
            src="../../assets/img/icon/icondefault.svg"
          />
          <img
            v-else
            width="50px"
            height="50px"
            :src="photoURL"
            style="border-radius: 50%; border: 5px solid #fff"
          />
        </span>
        <div>
          <span>
            <span class="custom-user-title text-white"
              >Hello {{ user.name }} !</span
            >
            <label class="label-greeting text-white"
              >Teacher <br /><br />
              <CProgress
                :value="value"
                :max="max2"
                class="mb-3"
                color="white"
                style="min-width: 200px; display: inline-grid"
              />
              <img src="../../assets/img/icon/point.svg" class="ml-2" />
              <br />
              <div style="min-width: 200px">
                <span class="float-left">
                  <span class="custom-credit">Redeem</span>
                </span>
              </div>
              <span class="float-right">1950/2000 pts</span>
            </label>
            <br /><br />
          </span>
          <span>
            <img
              style="position: absolute; top: 0; right: 30px"
              src="../../assets/img/icon/setting.svg" @click="GoToSetting()"
            />
          </span>

          <div style="clear: both"></div>
        </div>
      </CRow>
    </div>
        </CRow>
    </div>




    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
} from "hooper";

import MainlayoutBottom from "../../containers/TheBottomCustom.vue";

import TheSidebar from "../../containers/TheCustomSidebar.vue";
import TheSidebarRight from "../../containers/TheCustomSidebarRight.vue";
import "hooper/dist/hooper.css";

export default {
  name: "ProgressBars",
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
    MainlayoutBottom,
    TheSidebar,
    TheSidebarRight
  },
  data() {
    return {
      counter: 73,
      max: 100,
      max2: 50,
      value: 33.333333333,
      value3: 75,
      bars: [
        { color: "success", value: 75 },
        { color: "info", value: 75 },
        { color: "warning", value: 75 },
        { color: "danger", value: 75 },
        { color: "primary", value: 75 },
        { color: "secondary", value: 75 },
        { color: "dark", value: 75 },
      ],
      timer: null,
      striped: true,
      animate: true,
      max3: 100,
      values: [15, 30, 20],

      user: {},
      childs: [],
      studentProfileAuthorize: "",
      wallet: {},
      payment: {},
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },

  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetAuthorizeProfile(this.user.id);
            this.GetListChild(this.user.id);
            this.GetWalletAmount(this.user.id);
            this.GetTotalPaidAndUnpaid(this.user.id);
          }
        });
    },

    GetListChild() {
      this.$API
        .get(this.$AllStudentListAuthorize + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.childs = response.data;
            this.getPicChild(this.childs);
          }
        });
    },

     GetWalletAmount() {
      this.$API
        .get(this.$EwalletAmount + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.wallet = response.data;
          }
        });
    },

    getPicChild(index) {
      return (
        this.childs.Students[index].profileImagePath
      );
    },

    GetAuthorizeProfile() {
      this.$API
        .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfileAuthorize;
          }
        });
    },

    GetTotalPaidAndUnpaid() {
      this.$API
        .get(this.$TotalPaidAndUnpaid + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.payment = response.data;
          }
        });
    },

    clicked() {
      this.counter = Math.random() * this.max;
    },

    GoToManageStudent() {
      this.$router.push("/ParentProfile/ManageStudents");
    },

    GotoSalaryTutor() {
      this.$router.push("TutorSalary");
    },

    GoToSetting()
    {
       this.$router.push("TutorSetting");
    },

    GoToTutorJob()
    {
       this.$router.push("TutorJob");
    },

    GoToStudent()
    {
       this.$router.push("StudentList");
    },

     GoToTutorSchedule()
    {
       this.$router.push("TutorSchedule");
    },

    // GoToTutorScheduleTest()
    // {
    //    this.$router.push("TutorScheduleTest");
    // },

    GoToTopup()
    {
       this.$router.push("TutorTopup");
    },

    GoToBill() {
      this.$router.push("/ParentProfile/BillPayment");
    },

    GoToHistory() {
      this.$router.push("/ParentProfile/TransactionHistory");
    },
    GoToAttendance() {
      this.$router.push("TutorAttendance");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: auto;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

.progress {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.65625rem;
  border-radius: 0.25rem;
  background-color: #ebedef;
  height: 5px;
  border-radius: 10px;
}

.hooper-pagination {
  display: none;
}
.hooper {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: auto;
}

.custom-font-cards {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
}
</style>